module.exports = __webpack_public_path__ + "img/Link-Email256.d9f6d0b0.png";